import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { useState } from 'react';


function PhoneNumber() {
    const [value, setValue] = useState("");
    const [hasError, setHasError] = useState(false);

    return (
        <PhoneInput
            country={"in"}
            placeholder="Enter phone number"
            value={'+1 202-555-0143'}
            onChange={(phone, countryData) => {
                setValue(phone);
                console.log("Phone:", phone);
                console.log("Dial Code:", countryData?.dialCode);
            }}
            containerStyle={{
                width: "100%",
                backgroundColor: "#f9fafb",
                padding: "6px",
                border: hasError ? "1px solid #fb7185" : "1px solid #f9fafb",
                borderRadius: "8px",
                boxShadow: hasError
                    ? "0px 0px 6px #fb7185"
                    : "0px 4px 8px 3px #00000026",
                fontFamily: "Inter-Regular",
            }}
            inputStyle={{
                width: "100%",
                backgroundColor: "#f9fafb",
                border: "none",
                fontSize: "14px",
                fontWeight: "400",
                color: "#172b4d",
                boxShadow: "none",
                paddingLeft: "48px",
            }}
            buttonStyle={{
                backgroundColor: "#f9fafb",
                border: "none",
                borderRadius: "8px 0 0 8px",
            }}
        />
    );
}


export default PhoneNumber